export enum DocsVerificationStepEnum {
    START = 'start',
    START_CUSTOM_PARTNER = 'startCustomPartner',
    VERIFICATION = 'verification',
    FINISH = 'finish',
    EXPIRED = 'expired',
    DESKTOP_NOT_ALLOWED = 'desktopNotAllowed',
}
